/**
 * @owner @Appboy/core-objects
 */
import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsUserRelationshipTypeFields =
  "/data_objects/user_relationship_types/:rel_type_id/fields" as const;

/**
 * Invalidated after create mutations on this resource. Includes the user relationship type schema and
 * attributes GETs, since a new field changes what they return.
 */
export const customObjectsUserRelationshipTypeFieldsCacheKeys: AllRouteEndpoints[] = [
  customObjectsUserRelationshipTypeFields,
  "/data_objects/user_relationship_type_schema",
  "/data_objects/user_relationship_type_attributes",
];
